export default "__VITE_ASSET__CSxzZGN4__"